module.exports = __webpack_public_path__ + "img/器件名.37fc5079.svg";